import { BaseActionEnum } from "../action-menu/ActionMenuItem";
import { getActionMenuItems } from "../action-menu/BaseActions";


const summaryListingActionEnums = [
    BaseActionEnum.Configure,
    BaseActionEnum.Export,
    BaseActionEnum.Refresh,
    BaseActionEnum.Favorite
];

export const actionItems = getActionMenuItems(summaryListingActionEnums);        


